import { Client } from "../../clients/client";
import { ErrorTrackingApplyPromotionForm } from "./forms/ErrorTrackingApplyPromotionForm";
import { ErrorTrackingIncorrectInventoryForm } from "./forms/ErrorTrackingIncorrectInventoryForm";
import {
  IncorrectInventoryPayLoad,
  IncorrectInventoryPayLoadType
} from "./models/ErrorTrackingIncorrectInventory";

enum ItemType {
  PRODUCT = 1,
  BOX = 2,
  GIFT = 3
}
export class ErrorTrackingUseCase {
  constructor(private client: Client) {}

  getErrorTrackingApplyPromotion(form: ErrorTrackingApplyPromotionForm) {
    return this.client.errorTracking.findAllApplyPromotionErrorTrackings({
      page: form && form.page,
      limit: form && form.perPage,
      status: form.status ? form.status : undefined,
      search: form.search
    });
  }

  getErrorTrackingIncorrectInnventory(
    form: ErrorTrackingIncorrectInventoryForm
  ) {
    return this.client.errorTracking.findAllIncorrectInventoryErrorTrackings({
      page: form && form.page,
      limit: form && form.perPage,
      status: form.status ? form.status : undefined
    });
  }

  getIncorrectInventoryById(id: number) {
    return this.client.errorTracking.getIncorrectInventoryById(id);
  }

  incorrectInventoryPresenter(
    payloads: IncorrectInventoryPayLoad[]
  ): IncorrectInventoryPayLoadType {
    const products: IncorrectInventoryPayLoad[] = [];
    const boxs: IncorrectInventoryPayLoad[] = [];
    const gift: IncorrectInventoryPayLoad[] = [];
    payloads.forEach(payload => {
      if (payload.itemType == ItemType.PRODUCT) {
        products.push(payload);
      } else if (payload.itemType == ItemType.BOX) {
        boxs.push(payload);
      } else if (payload.itemType == ItemType.GIFT) {
        gift.push(payload);
      }
    });
    return {
      products,
      boxs,
      gift
    };
  }

  resolveApplyPromotionErrorTracking(id: number) {
    return this.client.errorTracking.resolveApplyPromotionErrorTracking(id);
  }
}
